import { InputMask, MaskProps } from '@react-input/mask';
import classnames from 'classnames';
import get from 'lodash/get';
import omit from 'lodash/omit';
import { ElementType } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { BsCalendar4 } from 'react-icons/bs';
import { ApiError } from '../../../api';
import { ShowFieldErrors } from '../../../utils/forms';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility, FormLabel } from '../FormLabel';
import './FormInputMaskField.scss';

interface FormInputMaskFieldProps {
  name: string;
  label: string;
  serverErrors?: ApiError;
  placeholder?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: ElementType<any>;
  showServerFieldErrors?: ShowFieldErrors;
  setShowServerFieldErrors?: (showServerFieldErrors: ShowFieldErrors) => void;
  errors?: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  extraFieldErrorsToHideOnChange?: string[];
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
  hideLabel?: boolean;
  isCalendarShownInCompactMode?: boolean;
  compact?: boolean;
  onToggleCalendar?: () => void;
}

export const FormInputMaskField = ({
  name,
  label,
  serverErrors,
  showServerFieldErrors,
  setShowServerFieldErrors,
  errors,
  register,
  extraFieldErrorsToHideOnChange = [],
  required = false,
  srOnlyLabel = false,
  visibility,
  hideLabel,
  compact,
  isCalendarShownInCompactMode,
  onToggleCalendar,
  placeholder = '',
  ...rest
}: FormInputMaskFieldProps & MaskProps & FormControlProps) => (
  <Form.Group className="mb-3" controlId={name}>
    {!hideLabel && (
      <FormLabel required={required} visibility={visibility} srOnlyLabel={srOnlyLabel}>
        {label}
      </FormLabel>
    )}
    <div className="position-relative form-input-mask-field">
      <Form.Control
        type="text"
        placeholder={placeholder}
        as={InputMask}
        {...register(name, {
          onChange: () =>
            setShowServerFieldErrors?.({
              ...omit(showServerFieldErrors, [name, ...extraFieldErrorsToHideOnChange]),
            }),
        })}
        isInvalid={!!errors?.[name] || !!get(showServerFieldErrors, name)}
        {...rest}
      />
      {compact ? (
        <Button
          variant="tertiary"
          size="sm"
          onClick={onToggleCalendar}
          className={classnames('open-close-calendar-btn', {
            ['open-close-calendar-btn-active']: isCalendarShownInCompactMode,
          })}
        >
          <BsCalendar4 size={16} />
        </Button>
      ) : null}
    </div>

    <FormFeedback
      clientError={errors?.[name]}
      serverErrors={get(showServerFieldErrors, name) ? get(serverErrors?.body, name) : null}
    />
  </Form.Group>
);
